import React from "react";
import { wxLinks } from "../data/wxLinks";


function WeatherLinks() {
  return (

<div style={{ marginTop: "8px", textAlign: "left" }}>
        
        <div style={{ marginTop: "6px" }}>Winds Aloft:</div>
        <a href={wxLinks.winds} target="_blank" rel="noopener noreferrer">
          {wxLinks.winds}
        </a>

        <div style={{ marginTop: "6px" }}>METAR:</div>
        <a href={wxLinks.metar} target="_blank" rel="noopener noreferrer">
          {wxLinks.metar}
        </a>
        <div style={{ marginTop: "6px" }}>TAF:</div>
        <a href={wxLinks.taf} target="_blank" rel="noopener noreferrer">
          {wxLinks.taf}
        </a>
 
     
        
      </div>
  );
}
   export default WeatherLinks;